import { CampaignsByCategory } from '@/types/api/campaigns';
import { useState } from 'react';
import BarChart from './BarChart';
import Table, { Column } from '@/components/Table';
import { LegendRow } from './LegendRow';
import { RevenueDashboardWidget } from '@/utils/mixpanelUtils/events';
import { mixpanelTrack } from '@/utils/mixpanelUtils/asyncMixpanel';
import { BarChartData } from '@/types';
import { usePageMetadata } from '@/hooks';
import { getCampaignTypesBarChartHoverEventByPageType } from '@/utils/mixpanelUtils/pageTypeHelpers';

const LEGEND_COLUMNS: Column[] = [
  { key: 'color', header: '' },
  { key: 'type', header: 'Campaign type' },
  { key: 'impressions', header: 'Impressions', align: 'right' },
  { key: 'earnings', header: 'Estimated earnings', align: 'right' },
];

export const CampaignTypesChart = ({ campaignTypes }: { campaignTypes: CampaignsByCategory }) => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const { page: pageType } = usePageMetadata();

  if (!pageType) throw new Error('Page type is required');

  const campaignTypesList = Object.entries(campaignTypes);

  const handleBarHover = (data: BarChartData) => {
    mixpanelTrack(getCampaignTypesBarChartHoverEventByPageType(pageType), {
      widget: RevenueDashboardWidget.CampaignTypes,
      page: pageType,
      campaignType: data.name,
    });
  };

  return (
    <div className="flex flex-col sm:flex-row justify-center items-center gap-4 md:gap-8 w-full px-5 max-w-[700px] mx-auto" data-testid="campaign-types-chart">
      <BarChart
        data={campaignTypes}
        className="w-full md:w-1/2 h-[250px]"
        selectedSegment={selectedCategory}
        setSelectedSegment={setSelectedCategory}
        ariaLabel="Campaign category distribution bar chart"
        onBarHover={handleBarHover}
      />

      <Table columns={LEGEND_COLUMNS} header={false} className="w-full md:w-1/2">
        {campaignTypesList.map(([type, stats], index) => (
          <LegendRow
            key={`campaign-${type}`}
            data={{ index, type, stats, categories: campaignTypes }}
            selectedCategory={selectedCategory}
          />
        ))}
      </Table>
    </div>
  );
};
